import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import {
  Autoplay,
  EffectFade,
  Navigation,
  Pagination,
} from "swiper";
// Import Swiper styles
import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/navigation";
import "swiper/css/pagination";

const HeroSlider = ({ images, onSwiperReady, onFirstImageLoaded }) => {
  return (
    <Swiper
      spaceBetween={30}
      effect={"fade"}
      autoplay={{
        delay: 2500,
        disableOnInteraction: false,
      }}
      loop={true}
      modules={[EffectFade, Autoplay, Navigation, Pagination]}
      className="hero-swiper absolute inset-0 w-full h-full z-0"
      onSwiper={() => {
        if (onSwiperReady) onSwiperReady();
      }}
    >
      {images.map((image, idx) => {
        const server = (process.env.REACT_APP_SERVER || "").replace(/\/$/, "");
        const isLocal = !server.startsWith('http') || server.includes('localhost:3000') || server.includes('localhost:8000');
        const baseSliderUrl = image.endsWith(".webp") ? image.substring(0, image.lastIndexOf(".webp")) : image;
        const srcSet = (image.endsWith(".webp") && isLocal) ? `${server}${baseSliderUrl}-320.webp 320w, ${server}${baseSliderUrl}-640.webp 640w, ${server}${baseSliderUrl}-1024.webp 1024w, ${server}${image} 1920w` : undefined;

        return (
          <SwiperSlide key={idx} className="w-full h-full">
            <img
              src={server + image}
              srcSet={srcSet}
              sizes="100vw"
              width="1500"
              height="982"
              alt="Kijeka Engineers — Material Handling Equipment"
              title="Kijeka Engineers"
              // First API slide is the LCP successor — eager + high priority
              loading={idx === 0 ? "eager" : "lazy"}
              fetchpriority={idx === 0 ? "high" : "low"}
              decoding={idx === 0 ? "sync" : "async"}
              className="w-full h-full object-cover"
              onLoad={idx === 0 ? () => {
                if (onFirstImageLoaded) onFirstImageLoaded();
              } : undefined}
            />
          </SwiperSlide>
        );
      })}
    </Swiper>
  );
};

export default HeroSlider;
